import { render, staticRenderFns } from "./ReservationCard.vue?vue&type=template&id=5d575170&scoped=true&"
import script from "./ReservationCard.vue?vue&type=script&lang=js&"
export * from "./ReservationCard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCard.vue?vue&type=style&index=0&id=5d575170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d575170",
  null
  
)

export default component.exports